import { HTTP_AP_RecordActivityEvent_Request_ActivityEvent } from '@api-new/reportingservice';
import { createAction, props } from '@ngrx/store';
import { AnalyticsEventModel } from '@shared/models/analytics-event.model';

export const logAnalyticsEvent = createAction('[ANALYTICS] Log Analytics Event', props<{ event: AnalyticsEventModel }>());

export const forceSentAnalyticsEventsInBuffer = createAction('[ANALYTICS] Force Sent Analytics Events In Buffer');

export const sendLogEvents = createAction(
  '[ANALYTICS] Send Log Events',
  props<{ events: HTTP_AP_RecordActivityEvent_Request_ActivityEvent[] }>(),
);
